import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, Row, Col, Button, Spinner } from "reactstrap";
import { generateNewContentParagraphAppTech } from 'store/thunks';


export interface IContentParagraphDetail {
    id: string | number;
    title?: string;
    content?: string;
    content_paragraph?: string;
    [key: string]: any;
}

interface ModalDetailContentProps {
    isOpen: boolean;
    toggle: () => void;
    triggerRefresh?: () => void;
    detail: IContentParagraphDetail | null;
}

const ModalDetailContent: React.FC<ModalDetailContentProps> = ({ isOpen, toggle, detail, triggerRefresh }) => {
    const { t } = useTranslation();

    const [isGenerating, setIsGenerating] = useState<boolean>(false);
    const [detailContent, setDetailContent] = useState<IContentParagraphDetail | null>(null);

    const generateNewContent = async (id: string | number) => {
        try {
            setIsGenerating((_prev) => true);
            const response: any = await generateNewContentParagraphAppTech({ blog_answer_id: id });
            setIsGenerating((_prev) => false);
            if (response?.code === 200) {
                toast(`${t("The process has been completed.")}`, CONFIG_OPTION_TOAST_NORMAL);
                setDetailContent((_prev: any) => ({ ..._prev, content_paragraph: response?.data || '' }));
                triggerRefresh && triggerRefresh();
            } else {
                toast(`${response || ""}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsGenerating((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    useEffect(() => {
        if (!!detail) {
            setDetailContent((_prev) => detail);
        }
    }, [JSON.stringify(detail)]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xxxl" className="modal-xxll" centered>
            <ModalHeader toggle={toggle}>
                {t('Detail Content Paragraph')}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <div className="mb-4">
                            <div className="mb-2 text-primary">{t('Title')}</div>
                            <div style={{
                                // minHeight: "30px",
                                whiteSpace: "pre-wrap",
                                border: "1px dashed var(--vz-primary)",
                                borderRadius: "6px",
                                padding: "12px",
                                // background: "#fafbfc"
                            }}>
                                <h5 className="mb-0">{detailContent?.title || <span className="text-muted">{t('No Title')}</span>}</h5>
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div>
                            <div className="mb-2 text-primary">{t('Content')}</div>
                            <div style={{
                                minHeight: "120px",
                                whiteSpace: "pre-wrap",
                                border: "1px dashed var(--vz-primary)",
                                borderRadius: "6px",
                                padding: "12px",
                                // background: "#fafbfc",
                                height: '50dvh',
                                overflowY: 'auto'
                            }}>
                                {detailContent?.content || <span className="text-muted">{t('No Content')}</span>}
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div>
                            <div className="mb-2 text-primary">{t('Content Generated')}</div>
                            <div style={{
                                minHeight: "120px",
                                whiteSpace: "pre-wrap",
                                border: "1px dashed var(--vz-primary)",
                                borderRadius: "6px",
                                padding: "12px",
                                // background: "#fafbfc",
                                height: '50dvh',
                                overflowY: 'auto'
                            }}>
                                {detailContent?.content_paragraph || <span className="text-muted">{t('No Content Generated')}</span>}
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="text-end mt-4 mb-3">
                    {/* <Button color="primary" onClick={() => {
                        generateNewContent(detailContent?.id || '');
                    }}
                        disabled={isGenerating || Number(detailContent?.retry_count) < 3}
                        style={{ width: '220px' }}
                        className="me-3"
                    >
                        <div className="d-flex justify-content-center align-items-center gap-2 align-middle  ">
                            {isGenerating ? <Spinner size="sm" className="me-1" /> : <i className="ri-refresh-line" style={{ lineHeight: '22px' }} />}  <div>{t('Button Generate New Content')}</div>
                        </div>
                    </Button> */}
                    <Button color="secondary" onClick={toggle} style={{ width: '90px' }}>
                        {t('Button Close')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalDetailContent;
